import { render, staticRenderFns } from "./sidebar_main_menu.vue?vue&type=template&id=63a2b256&scoped=true&"
import script from "./sidebar_main_menu.vue?vue&type=script&lang=js&"
export * from "./sidebar_main_menu.vue?vue&type=script&lang=js&"
import style0 from "./sidebar_main_menu.vue?vue&type=style&index=0&id=63a2b256&prod&scoped=true&lang=scss&"
import style1 from "./sidebar_main_menu.vue?vue&type=style&index=1&id=63a2b256&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a2b256",
  null
  
)

export default component.exports